import Dashboard from "./components/DashboardWrapper";
import Account from "./pages/Account";
import Billing from "./pages/Billing";
import Chat from "./pages/Chat";
import Home from "./pages/Home";
import Meetings from "./pages/Meetings";
import Project from "./pages/Project";

const routes = [{
    path: "/dashboard",
    element: <Dashboard />,
    children: [
        {
            path: "",
            element: <Home />,
        },
        {
            path: "project/:id",
            element: <Project />,
        },
        {
            path: "account",
            element: <Account />,
        },
        {
            path: "chat",
            element: <Chat />,
        },
        {
            path: "meetings",
            element: <Meetings />,
        },
        {
            path: "billing",
            element: <Billing />,
        },
    ],
}]

export default routes;